import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import DataCard from './DataCard';

class DataCardDependencyError extends Error {
  constructor(...params) {
    super(...params);
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, DataCardDependencyError);
    }
    this.name = 'DataCardDependencyError';
  }
  toString() {
    return `${this.name}: ${this.message}`;
  }
}

export const useSelectedAlert = () => {
  const { alerts, selectedAlertID } = useSelector(state => {
    const { incidents } = state;
    if (!incidents) {
      throw new DataCardDependencyError(
        'The incidents slice is missing in redux state.',
      );
    }
    return incidents;
  });
  const [currentAlert, setCurrentAlert] = useState(undefined);
  useEffect(() => {
    setCurrentAlert(alerts[selectedAlertID]);
  }, [alerts, selectedAlertID]);
  return currentAlert || {};
};

export const useCurrentAdrData = currentAlert => {
  const { data: adrData = {} } = useSelector(state => {
    const { adrData } = state;
    if (!adrData) {
      throw new DataCardDependencyError(
        'The adrData slice is missing in redux state.',
      );
    }
    return adrData;
  });
  const [currentAdrData, setCurrentAdrData] = useState(null);
  useEffect(() => {
    if (!currentAlert) {
      setCurrentAdrData(null);
      return;
    }
    const { alert_id: alertId } = currentAlert;
    setCurrentAdrData(adrData[`alert://${alertId}`]);
  }, [currentAlert, adrData]);
  return currentAdrData;
};

const DataCardContainer = ({
  accessToken,
  height,
  onClose,
  isCentralStation,
  authorizedEntity,
}) => {
  const currentAlert = useSelectedAlert();
  const currentAdrData = useCurrentAdrData(currentAlert);

  return (
    <DataCard
      accessToken={accessToken}
      alert={currentAlert}
      adrData={currentAdrData}
      height={height}
      onClose={onClose}
      isCentralStation={isCentralStation}
      authorizedEntity={authorizedEntity}
      data-name="alert-data-card"
    />
  );
};

export default DataCardContainer;
